<template>
  <div class="filters">
    <section
      class="filters__wrapper"
      :style="isOpen ? 'transform: translate(0)' : ''"
    >
      <div v-if="loading" class="filters__loading-overlay">
        <div class="filters__loading-overlay__container">
          <loader :show_timing_slot="true" />
        </div>
      </div>

      <header class="filters__wrapper__header">
        <b-container fluid>
          <div
            class="filters__wrapper__header-top d-flex align-items-center justify-content-between"
          >
            <span class="filters__title">Filtri</span>
            <button
              role="button"
              type="button"
              class="close variant-white"
              @click="toggle_filters"
            >
              <vb-icon name="cross_circle" :size="25" />
            </button>
          </div>
        </b-container>
      </header>

      <main class="filters__panel-wrap">
        <div class="filters__panel--search-by">
          <search-by-credit is_switch />
          <!-- TAZ-570 https://salabam.atlassian.net/browse/TAZ-570
          <search-by-connections is_switch />
          -->
          <search-by-bags />
        </div>

        <div v-if="has_active_filters" class="filters__panel--active-filters">
          <filters-tags />
        </div>

        <div class="filters__panel">
          <div class="filters__content">
            <p class="filters__section__title">Orario andata</p>
            <div class="filters__time-buttons">
              <filters-time-range
                v-for="filter_id in Object.keys(time_ranges)"
                :key="filter_id"
                :filter_id="filter_id"
                :current_filter="filter_round_trip_departure"
                :set_time_range_filter="
                  (new_filter) => (filter_round_trip_departure = new_filter)
                "
              />
            </div>
          </div>
        </div>

        <!-- disattivato https://trello.com/c/BSOxHzdA/1818-rifiniture-filtri-ricerca
              <div class="filters__panel">
                <div class="filters__content">
                  <p class="filters__section__title">
                    Orario Arrivo
                  </p>
                  <div class="filters__time-buttons">
                    <div class="filters__time-button" :class="filter_round_trip_arrival == 'morning' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival !== 'morning') {
                        filter_round_trip_arrival = 'morning'
                      } else {
                        filter_round_trip_arrival = ''
                      }
                    }">
                      <vb-icon class="filters__time-button__icon" name="sun" :size="19" />
                      <div class="filters__time-button__text">
                        <div>Mattina</div>
                        <div class="filters__time-button__hours">(6:00 - 12:00)</div>
                      </div>
                    </div>
                    <div class="filters__time-button" :class="filter_round_trip_arrival == 'early_afternoon' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival == 'early_afternoon') {
                        filter_round_trip_arrival = ''
                      } else {
                        filter_round_trip_arrival = 'early_afternoon'
                      }
                    }">
                      <vb-icon class="filters__time-button__icon" name="sun-half" :size="19" />
                      <div class="filters__time-button__text">
                        <div>Primo pomeriggio</div>
                        <div class="filters__time-button__hours">(12:00 - 15:00)</div>
                      </div>
                    </div>
                    <div class="filters__time-button" :class="filter_round_trip_arrival == 'late_afternoon' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival == 'late_afternoon') {
                        filter_round_trip_arrival = ''
                      } else {
                        filter_round_trip_arrival = 'late_afternoon'
                      }
                    }">
                      <vb-icon class="filters__time-button__icon" name="sun-half" :size="19" />
                      <div class="filters__time-button__text">
                        <div>Tardo pomeriggio</div>
                        <div class="filters__time-button__hours">(15:00 - 18:00)</div>
                      </div>
                    </div>
                    <div class="filters__time-button" :class="filter_round_trip_arrival == 'evening' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival == 'evening') {
                        filter_round_trip_arrival = ''
                      } else {
                        filter_round_trip_arrival = 'evening'
                      }
                    }">
                      <vb-icon class="filters__time-button__icon" name="moon" :size="19" />
                      <div class="filters__time-button__text">
                        <div>Sera</div>
                        <div class="filters__time-button__hours">(18:00 - 6:00)</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

        <div class="filters__panel" v-if="return_flight">
          <div class="filters__content">
            <p class="filters__section__title">Orario ritorno</p>
            <div class="filters__time-buttons">
              <filters-time-range
                v-for="filter_id in Object.keys(time_ranges)"
                :key="filter_id"
                :filter_id="filter_id"
                :current_filter="filter_return_trip_departure"
                :set_time_range_filter="
                  (new_filter) => (filter_return_trip_departure = new_filter)
                "
              />
            </div>
          </div>
        </div>

        <div class="filters__panel" v-if="has_results">
          <div class="filters__content">
            <p class="filters__section__title">Prezzo</p>
            <filter-price-range />
          </div>
        </div>

        <div class="filters__panel">
          <div class="filters__content">
            <p class="filters__section__title">Classe</p>
            <search-by-cabin />
          </div>
        </div>

        <div v-if="Object.keys(carriers).length > 0" class="filters__panel">
          <div class="filters__content">
            <p class="filters__section__title">Compagnie aeree</p>
            <div class="filters__carriers">
              <vb-checkbox
                v-for="carrier in carriers"
                :key="`${_uid}:carrier_filter:${carrier.value}`"
                :ref="`carrier_filter:${carrier.value}`"
                @change="() => toggle_carrier_filter(carrier.value)"
                :vb_options="{
                  text: `${carrier.text} (${carrier.amount})`,
                  checked: filter_carriers.includes(carrier.value),
                  type: 'light',
                }"
              />
            </div>
          </div>
        </div>

        <div v-if="show_developer_tools()" class="filters__panel">
          <div class="filters__content">
            <p class="filters__section__title">Provider (dev)</p>
            <div class="filters__carriers">
              <vb-checkbox
                v-for="provider in providers"
                :key="`${_uid}:provider_filter:${provider.value}`"
                :ref="`provider_filter:${provider.value}`"
                @change="() => toggle_provider_filter(provider.value)"
                :vb_options="{
                  text: `${provider.text} (${provider.amount})`,
                  checked: filter_providers.includes(provider.value),
                  type: 'light',
                }"
              />
            </div>
          </div>
        </div>
      </main>

      <footer class="filters__wrapper__footer">
        <vb-button
          :vb_options="{
            disabled: !has_filters,
            text: 'Cancella filtri',
            variant: 'info',
            size: 'sm',
          }"
          @click="remove_all_filters"
        >
        </vb-button>
        <vb-button
          class="semibold"
          :vb_options="{
            text: 'Mostra risultati',
            size: 'md',
          }"
          @click="toggle_filters"
        >
        </vb-button>
      </footer>
    </section>
  </div>
</template>
<script>
import SearchByCredit from "@liveflight/components/blocks/filters/search-by-credit";
import SearchByBags from "@liveflight/components/blocks/filters/search-by-bags";
import SearchByCabin from "@liveflight/components/blocks/filters/search-by-cabin";
// TAZ-570 https://salabam.atlassian.net/browse/TAZ-570
// import SearchByConnections from "@liveflight/components/blocks/filters/search-by-connections";
import FiltersTimeRange from "@liveflight/components/blocks/filters/filters-time-range.vue";
import FiltersTags from "@liveflight/components/blocks/filters/filters-tags.vue";
import FilterPriceRange from "@liveflight/components/blocks/filters/filter-price-range.vue";
import { time_ranges } from "@liveflight/resources/filters";
import {
  remove_all_filters,
  get_active_filters,
} from "@liveflight/utilities/filters";
import { list_active_providers } from "@liveflight/providers";

export default {
  name: "filters",
  props: {
    filtered_all_carriers: {
      type: Array,
      default: () => [],
    },
    flights_count: {
      type: Number,
      default: () => 0,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "search-by-credit": SearchByCredit,
    // TAZ-570: "search-by-connections": SearchByConnections,
    "search-by-bags": SearchByBags,
    "search-by-cabin": SearchByCabin,
    "filters-time-range": FiltersTimeRange,
    "filters-tags": FiltersTags,
    "filter-price-range": FilterPriceRange,
  },
  data() {
    return {
      // data e non computed perchè NON deve essere reattiva a modifiche nel booking engine
      // in caso contrario il filtro potrebbe sparire/apparire quando cambio A - A/R nel booking engine in modo incoerente ai risultati che sto mostrando
      return_flight: this.$store.state.liveflight.return_flight,
      time_ranges,
    };
  },
  computed: {
    carriers: {
      get() {
        return this.calculate_carriers();
      },
      set() {},
    },
    filter_carriers: {
      get() {
        return this.$store.state.liveflight.filter_carriers;
      },
      set(value) {
        this.$store.commit("liveflight/filter_carriers", value);
      },
    },
    providers() {
      return this.calculate_providers();
    },
    filter_providers: {
      get() {
        return this.$store.state.liveflight.filter_providers || [];
      },
      set(value) {
        this.$store.commit("liveflight/filter_providers", value);
      },
    },
    filter_round_trip_departure: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_departure;
      },
      set(value) {
        this.$store.commit("liveflight/filter_round_trip_departure", value);
        this.calculate_carriers();
      },
    },
    filter_round_trip_arrival: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_arrival;
      },
      set(value) {
        this.$store.commit("liveflight/filter_round_trip_arrival", value);
        this.calculate_carriers();
      },
    },
    filter_return_trip_departure: {
      get() {
        return this.$store.state.liveflight.filter_return_trip_departure;
      },
      set(value) {
        this.$store.commit("liveflight/filter_return_trip_departure", value);
        this.calculate_carriers();
      },
    },
    filter_included_bags: {
      get() {
        return this.$store.state.liveflight.filter_included_bags;
      },
      set(value) {
        this.$store.commit("liveflight/filter_included_bags", value);
        this.calculate_carriers();
      },
    },
    filter_extra_bags: {
      get() {
        return this.$store.state.liveflight.filter_extra_bags;
      },
      set(value) {
        this.$store.commit("liveflight/filter_extra_bags", value);
        this.calculate_carriers();
      },
    },
    has_filters() {
      return this.get_active_filters().length;
    },
    has_active_filters() {
      return this.get_active_filters().length > 0;
    },
    has_results() {
      const results = this.$store.state.liveflight.results;
      return results && results.flights && results.flights.length > 0;
    },
    loading() {
      return this.$store.state.liveflight.loading;
    },
  },
  methods: {
    get_active_filters,
    remove_all_filters,
    /**
     * Build the dev-panel provider tally.
     * Seeds every registered provider at 0 so the checkbox doesn't
     * disappear when the user filters to a currently-empty provider.
     */
    calculate_providers() {
      const tally = {};
      list_active_providers().forEach((id) => {
        tally[id] = { text: id, value: id, amount: 0 };
      });
      const flights = Array.isArray(this.filtered_all_carriers)
        ? this.filtered_all_carriers
        : [];
      flights.forEach((offer) => {
        const id = offer && offer._provider;
        if (!id) {
          return;
        }
        if (!tally[id]) {
          tally[id] = { text: id, value: id, amount: 0 };
        }
        tally[id].amount += 1;
      });
      return Object.values(tally).sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });
    },
    /**
     * Tally carriers from the normalised FlightOffer shape.
     * carrier.code + carrier.name live inline on every segment, so we
     * no longer need the legacy results.dictionaries.carriers lookup.
     */
    calculate_carriers() {
      const flights = this.filtered_all_carriers;
      if (!Array.isArray(flights) || flights.length === 0) {
        return [];
      }

      const tally = {};
      flights.forEach((offer) => {
        const first_itinerary = offer && offer.itineraries && offer.itineraries[0];
        const first_segment = first_itinerary && first_itinerary.segments[0];
        if (!first_segment || !first_segment.carrier) {
          return;
        }
        const { code = '', name = '' } = first_segment.carrier;
        if (!code) {
          return;
        }
        if (!tally[code]) {
          tally[code] = { text: name || code, value: code, amount: 0 };
        }
        tally[code].amount += 1;
      });

      return Object.values(tally).sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });
    },

    toggle_filters() {
      this.$emit("toggle-filters");
    },

    toggle_carrier_filter(carrierValue) {
      const selected = this.filter_carriers.includes(carrierValue);
      if (!selected) {
        this.filter_carriers = [...this.filter_carriers, carrierValue];
      } else {
        this.filter_carriers = this.filter_carriers.filter(
          (c) => c !== carrierValue,
        );
      }

      this.$nextTick(() => {
        this.scroll_top();
      });
    },

    toggle_provider_filter(providerValue) {
      const selected = this.filter_providers.includes(providerValue);
      if (!selected) {
        this.filter_providers = [...this.filter_providers, providerValue];
      } else {
        this.filter_providers = this.filter_providers.filter(
          (p) => p !== providerValue,
        );
      }

      this.$nextTick(() => {
        this.scroll_top();
      });
    },
  },
};
</script>

<style lang="scss">
.filters {
  &__title {
    color: var(--primary);
    font-size: $font-size-lg;
    font-weight: $vb-font-weight-semibold;

    &--desktop {
      @include media-breakpoint-down(xl) {
        display: none;
      }
    }
  }

  &__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    z-index: 1001;
    background: var(--white);
    height: 100%;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
    transform: translate(100%);
    transition: transform 0.2s ease;

    @include media-breakpoint-up(xl) {
      display: block;
      position: static;
      width: auto;
      max-width: none;
      z-index: auto;
      box-shadow: none;
      background: transparent !important;
      transform: translate(0);
    }

    &__header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      font-size: 17px;
      background-color: var(--white);
      border-bottom: 1px solid $gray-200;
      z-index: 2;
      padding: $grid-gutter-width/2 0;

      @include media-breakpoint-up(xl) {
        display: none;
      }
    }

    &__footer {
      position: absolute;
      padding: $grid-gutter-width/2;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 17px;
      background-color: var(--white);
      z-index: 2;
      border-top: 1px solid $gray-200;
      box-shadow: 0 -2px 16px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.04);

      display: flex;
      justify-content: space-between;

      @include media-breakpoint-up(xl) {
        display: none;
      }
    }
  }

  &__panel-wrap {
    border-radius: $border-radius-lg * 2;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    padding: $grid-gutter-width * 2 $grid-gutter-width / 2 $grid-gutter-width * 3 $grid-gutter-width / 2;

    @include media-breakpoint-up(xl) {
      height: auto;
      padding: 0;
    }
  }

  &__panel {
    $panel-border-radius: $border-radius-lg * 2;

    &:first-child {
      border-top-left-radius: $panel-border-radius;
      border-top-right-radius: $panel-border-radius;
    }

    &:last-child {
      border-bottom-left-radius: $panel-border-radius;
      border-bottom-right-radius: $panel-border-radius;
    }

    background-color: var(--white);
    padding: $grid-gutter-width/2 0;

    &:not(:last-child) {
      border-bottom: 1px solid $gray-200;
    }

    @include media-breakpoint-up(xl) {
      padding: $grid-gutter-width/2;
    }

    &:last-child {
      padding-bottom: 0;

      @include media-breakpoint-up(xl) {
        padding-bottom: $grid-gutter-width/3;
      }
    }

    &--search-by {
      @extend .filters__panel;
      background-color: transparent;
      display: flex;
      flex-direction: column;
      gap: 5px;

      .custom-checkbox {
        margin-bottom: 0;
      }
      .custom-control-input:checked ~ .custom-control-label::after {
        background-color: var(--primary) !important;
      }
      select {
        padding: 0;
      }
    }

    &--active-filters {
      @extend .filters__panel;
      background-color: transparent;
      //display: flex;
      //flex-direction: column;
      //gap: 5px;
    }
  }

  &__content {
    position: relative;
  }

  &__section__title {
    margin-bottom: $grid-gutter-width / 3;
    font-weight: $vb-font-weight-semibold;
    &-sub {
      text-decoration: underline;
    }
  }

  &__section__subtitle {
    display: block;
    font-size: $font-size-sm;
    line-height: 1.2em;
    margin-top: 0.1em;
  }

  &__time-buttons {
    display: flex;
    flex-direction: column;
    gap: $grid-gutter-width/3;
  }

  &__carriers {
    display: flex;
    flex-direction: column;

    .custom-control-input:checked ~ .custom-control-label .vb-check__title {
      color: var(--info);
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      background-color: var(--info);
    }
  }

  &__loading-overlay {
    position: absolute;
    inset: 0;
    z-index: 3; // above header/footer (z-index: 2)
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.7); // fallback semi-transparency where blur is unsupported
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px); // required for iOS Safari

    &__container {
      padding: $grid-gutter-width;
      margin: $grid-gutter-width / 2;
    }
  }

  .custom-checkbox {
    margin-bottom: $grid-gutter-width/2;

    @include media-breakpoint-up(xl) {
      margin-bottom: $grid-gutter-width/4;
    }
  }

  &__panel:not(.filters__panel--search-by) .custom-checkbox {
    width: 100%;
    label:before,
    label:after {
      border-color: $gray-300;
    }
  }

  .dropdown {
    width: 100%;
    .btn > .d-flex {
      min-width: 100%;
    }
  }
}
</style>
